module.exports = __webpack_public_path__ + "static/media/คู่มือการใช้งานระบบPDMO_PORTAL.30eeef4a.pdf";